import { render, staticRenderFns } from "./bar-chart-card.vue?vue&type=template&id=41bd36b2&scoped=true"
import script from "./bar-chart-card.ts?vue&type=script&lang=ts&external"
export * from "./bar-chart-card.ts?vue&type=script&lang=ts&external"
import style0 from "./bar-chart-card.scss?vue&type=style&index=0&id=41bd36b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bd36b2",
  null
  
)

export default component.exports